import './ErrorMessage.css'

export default function ErrorMessage({ msg }) {
  return <div className='ErrorMessage'>{msg}</div>
}
